class DiscountFilter extends HTMLElement {
  // Keep in sync with the mobile breakpoint in DeviceWidth (max-width: 1023px)
  static DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

  connectedCallback() {
    this.stripForeignParams();

    this.toggleBtn = this.querySelector('[data-toggle]');
    if (!this.toggleBtn) return;

    this.desktopQuery = window.matchMedia(DiscountFilter.DESKTOP_MEDIA_QUERY);
    this.reserveSortByWidth();
    this.syncExpandedState();

    // On mobile the click is handled by <mobile-drawer> through data-drawer-toggle
    this.toggleBtn.addEventListener('click', () => {
      if (this.desktopQuery.matches) this.toggleAttribute('open');
    });

    // Delegated: the Clear all button is re-rendered after every filter update
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-discount-clear]')) this.clearAll();
    });
  }

  // Unchecks every discount option and lets <facet-filters-form> submit through its input listener
  clearAll() {
    const checkedInputs = this.querySelectorAll('input[type="checkbox"]:checked');
    checkedInputs.forEach((input) => {
      input.checked = false;
    });
    checkedInputs[0]?.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /**
   * Mirrors the open state on the toggle's aria-expanded. The tab opens either through the [open]
   * attribute (desktop dropdown) or through the "open" class that <mobile-drawer> toggles on the
   * button (mobile drawer, also closed from the overlay), so both are observed.
   */
  syncExpandedState() {
    const update = () => {
      const isExpanded = this.hasAttribute('open') || this.toggleBtn.classList.contains('open');
      this.toggleBtn.setAttribute('aria-expanded', String(isExpanded));
    };

    const observer = new MutationObserver(update);
    observer.observe(this, { attributes: true, attributeFilter: ['open'] });
    observer.observe(this.toggleBtn, { attributes: true, attributeFilter: ['class'] });
    update();
  }

  // Sort By is absolutely positioned on desktop, so its container takes no space: reserve its width (open too, it grows) to keep this tab after it
  reserveSortByWidth() {
    const sorting = this.closest('.facet-filters__buttons')?.querySelector('.facet-filters__sorting');
    const sortBy = sorting?.querySelector('sort-by');
    if (!sortBy) return;

    const update = () => {
      const isAbsolute = getComputedStyle(sortBy).position === 'absolute';
      sorting.style.minWidth = isAbsolute ? `${sortBy.offsetWidth}px` : '';
    };

    update();
    this.desktopQuery.addEventListener('change', update);
    new ResizeObserver(update).observe(sortBy);
  }

  stripForeignParams() {
    const foreignParams = (this.dataset.foreignParams ?? '').split(',').filter(Boolean);
    const searchParams = new URLSearchParams(window.location.search);
    if (!foreignParams.some((param) => searchParams.has(param))) return;

    foreignParams.forEach((param) => searchParams.delete(param));
    const cleanParams = searchParams.toString();
    const cleanQuery = cleanParams ? `?${cleanParams}` : '';

    // Replace (not push) so Back does not return to the foreign-filtered URL
    FacetFiltersForm.searchParamsInitial = cleanParams;
    history.replaceState({ searchParams: cleanParams }, '', `${window.location.pathname}${cleanQuery}`);
    FacetFiltersForm.renderPage(cleanParams, null, false);
  }
}

customElements.define('discount-filter', DiscountFilter);
